export class Token {
    jwt: string;
}